// 学生端路由 无动态
const stuRoutes = [
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/home',
        name: 'home',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/home/home.vue'),
      },
    ]
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/batch',
        name: 'batch',
        meta: {
          title: '批次列表',
          isStudent: true
        },
        component: () => import('@/views/student/batch/batch.vue'),
      }
    ]
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/userConfig',
        name: 'userConfig',
        meta: {
          title: '账户设置',
          isStudent: true
        },
        component: () => import('@/views/student/userConfig/userConfig.vue'),
      },
      {
        path: '/stuHome/updatePassword',
        name: 'updatePassword',
        meta: {
          title: '修改密码',
          isStudent: true
        },
        component: () => import('@/views/student/resetPassword/updatePassword.vue'),
      }
    ]
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/stuApply',
        name: 'stuApply',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/stuApply/stuApply.vue'),
      },
      {
        path: '/stuHome/stuExamine',
        name: 'stuExamine',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/stuApply/examine.vue'),
      },
      {
        path: '/stuHome/secondApply',
        name: 'secondApply',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/stuApply/secondApply.vue'),
      },
    ]
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/payFee',
        name: 'payFee',
        meta: {
          title: '缴费',
          isStudent: true
        },
        component: () => import('@/views/student/payFee/payFee.vue'),
      },
      {
        path: '/stuHome/payTransfer',
        name: 'payTransfer',
        meta: {
          title: '缴费状态确认',
          isStudent: true
        },
        component: () => import('@/views/student/payFee/payTransfer.vue'),
      }
    ]
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/ticket',
        name: 'ticket',
        meta: {
          title: '准考证',
          isStudent: true
        },
        component: () => import('@/views/student/ticket/ticket.vue'),
      }
    ]
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/exam',
        name: 'stuExam',
        meta: {
          title: '考试',
          isStudent: true
        },
        component: () => import('@/views/student/exam/exam.vue'),
      }
    ]
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/score',
        name: 'stuScore',
        component: () => import('@/views/student/score/score.vue'),
        meta: {
          title: '成绩查询',
          isStudent: true
        }
      },
      {
        path: '/stuHome/representations',
        name: 'representations',
        component: () => import('@/views/student/score/representations.vue'),
        meta: {
          title: '复核',
          isStudent: true
        }
      },
    ],
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/stuNotice',
        name: 'stuNotice',
        meta: {
          title: '院校公告',
          isStudent: true
        },
        component: () => import('@/views/student/notice/notice.vue'),
      },
      {
        path: '/stuHome/stuNoticeInfo',
        name: 'stuNoticeInfo',
        meta: {
          title: '公告详情',
          isStudent: true
        },
        component: () => import('@/views/student/notice/noticeinfo.vue'),
      }
    ],
  },
]

export default stuRoutes